/* eslint-disable react-hooks/exhaustive-deps */
import { confirmDialog, CustomCollapseCard, Text } from '@src/components';
import { Radio } from 'antd';
import React, { useCallback, useEffect } from 'react';
import '@src/styles/balanceUpload/orderType.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  loadBalancesUpdate,
  prepareLoadBalance,
  setOrderStep,
  setCurrentLoadBalance,
  setExcelSuccess,
} from '@src/store/slice/balanceUploadSlice';
import { useHistory } from 'react-router-dom';
import { setDraftType } from '@src/store/slice/draftOrderSlice';
import {
  getLoadBalanceDetailsGetPagedList,
  loadBalancePopUpMessage,
  setDetailTableFilterClear,
  setExcelUploadStatus,
  setSelectedBalanceUploadDetails,
  setBalanceUploadClear,
} from '@src/store/slice/balanceUploadDetailSlice';
import useUnload from '@src/hooks/useUnLoad.js';

const OrderType = () => {
  const history = useHistory();
  const { currentLoadBalance, excelLoadBalanceList } = useSelector((state) => state?.balanceUpload);
  const { excelUploadStatus, balanceUploadDetails } = useSelector((state) => state?.balanceUploadDetail);
  const dispatch = useDispatch();

  const typeChangeProcess = async (isNewLoadBalance, newOrderProcessType) => {
    // Aynı orderProcessType tekrar seçildiğinde prepareLoadBalance no-op olsun;
    // her tıklamada 3 SP zinciri tetiklenmesini engeller.
    if (currentLoadBalance?.orderProcessType === newOrderProcessType) {
      return;
    }
    if (!isNewLoadBalance) {
      let data = {
        orderProcessType: newOrderProcessType,
      };
      data.willBeDeletedId = currentLoadBalance?.id;
      await dispatch(prepareLoadBalance(data));
      await dispatch(setSelectedBalanceUploadDetails([]));
    } else {
      let data = {
        orderProcessType: newOrderProcessType,
      };
      if (!isNewLoadBalance) {
        data.willBeDeletedId = currentLoadBalance?.id;
      }
      await dispatch(prepareLoadBalance(data));
      await dispatch(setSelectedBalanceUploadDetails([]));
    }
  };

  const loadBalanceDetailsGetPagedList = useCallback(
    async (data, pageNumber, pageSize) => {
      await dispatch(
        getLoadBalanceDetailsGetPagedList({
          body: { ...data, loadBalanceId: currentLoadBalance?.id },
          pageNumber,
        }),
      );
    },
    [currentLoadBalance, dispatch],
  );

  const handleDraft = async (newOrderProcessType) => {
    const body = { orderProcessType: newOrderProcessType };
    const action = await dispatch(loadBalancePopUpMessage(body));
    if (loadBalancePopUpMessage.fulfilled.match(action)) {
      confirmDialog({
        title: <Text t="attention" />,
        message: action?.payload?.message,
        okText: <Text t="yes" />,
        onOk: async () => {
          await dispatch(setDraftType(2));
          await dispatch(setSelectedBalanceUploadDetails([]));
          history.push('/ticket-restaurant/draft-order');
        },
      });
    }
  };

  useUnload(async (e) => {
    if (excelLoadBalanceList?.orderStep === 3 || currentLoadBalance?.orderProcessType === 3) {
      await dispatch(
        setCurrentLoadBalance({ ...currentLoadBalance, totalPrice: 0, totalCount: 0 }),
      );
    }
  });

  const callBackBalanceClear = useCallback(async () => {
    await dispatch(setBalanceUploadClear());
    await dispatch(setExcelSuccess(false));
  }, [dispatch, balanceUploadDetails, currentLoadBalance]);

  useEffect(async () => {
    const third = currentLoadBalance?.orderProcessType === 3 ? 3 : null;
    if (currentLoadBalance?.orderProcessType === 3) {
      await dispatch(setOrderStep(third));
    }
  }, [currentLoadBalance?.orderProcessType, dispatch]);

  const handlePreviousOrder = async (newOrderProcessType, isNewLoadBalance) => {
    await typeChangeProcess(isNewLoadBalance, newOrderProcessType);
    dispatch(setExcelUploadStatus(false));
    await dispatch(setOrderStep(1));
  };

  const orderTypeChange = async (e) => {
    dispatch(setDetailTableFilterClear());
    const newOrderProcessType = e.target.value;
    await dispatch(setOrderStep(newOrderProcessType));

    const isNewLoadBalance = currentLoadBalance?.id === 0;
    if (newOrderProcessType === 4) {
      if (Number(currentLoadBalance?.totalPrice) !== 0) {
        confirmDialog({
          title: <Text t="attention" />,
          htmlContent: (
            <Text t="withThisOptionYouHaveSelectedYouAre" />
          ),
          onOk: () => {
            handleDraft(newOrderProcessType);
          },
        });
      } else {
        handleDraft(newOrderProcessType);
      }
      return null;
    } else if (newOrderProcessType === 1) {
      if (Number(currentLoadBalance?.totalPrice) !== 0) {
        handlePreviousOrder(newOrderProcessType, isNewLoadBalance);
      } else {
        await dispatch(setOrderStep(null));

        handlePreviousOrder(newOrderProcessType, isNewLoadBalance);
      }
      return;
    } else if (currentLoadBalance?.orderProcessType === 2 && Number(currentLoadBalance?.totalPrice) !== 0) {
      confirmDialog({
        title: <Text t="attention" />,
        htmlContent: (
          <Text t="withThisOptionYouHaveSelectedYouAre" />
        ),
        onOk: async () => {
          await dispatch(setDraftType(newOrderProcessType));
          typeChangeProcess(isNewLoadBalance, newOrderProcessType);
        },
      });
    } else if (currentLoadBalance?.orderProcessType === 3 && excelUploadStatus) {
      confirmDialog({
        title: <Text t="attention" />,
        htmlContent: (
          <Text t="withThisOptionYouHaveSelectedYouAre" />
        ),
        onOk: async () => {
          await dispatch(setDraftType(newOrderProcessType));
          typeChangeProcess(isNewLoadBalance, newOrderProcessType);
          dispatch(setExcelUploadStatus(false));
        },
      });
    } else {
      if (newOrderProcessType === 3) {
        callBackBalanceClear();
        if (excelLoadBalanceList?.orderStep === 3 || currentLoadBalance?.orderProcessType === 3) {
          await dispatch(
            setCurrentLoadBalance({ ...currentLoadBalance, totalPrice: 0, totalCount: 0 }),
          );
        }
      }
      typeChangeProcess(isNewLoadBalance, newOrderProcessType);
      dispatch(setExcelUploadStatus(false));
    }
  };

  const onProcessTypeChange = async (e) => {
    const newOrderProcessType = e.target.value;

    if (excelLoadBalanceList?.orderStep === 3 || currentLoadBalance?.orderProcessType === 3) {
      if (Number(currentLoadBalance?.totalPrice) !== 0 && excelLoadBalanceList?.isSuccess === true) {
        confirmDialog({
          title: <Text t="attention" />,
          htmlContent: (
            <Text t="withThisOptionYouHaveSelectedYouAre" />
          ),
          onOk: async () => {
            callBackBalanceClear();
            await dispatch(
              setCurrentLoadBalance({ ...currentLoadBalance, totalPrice: 0, totalCount: 0 }),
            );
            await dispatch(
              loadBalancesUpdate({ ...currentLoadBalance, periodType: newOrderProcessType }),
            );
            await loadBalanceDetailsGetPagedList({}, 1, 20);
            document.getElementById('loadBalanceFilterForm')?.reset();
            await dispatch(setDetailTableFilterClear());
          },
        });
      } else {
        callBackBalanceClear();
        await dispatch(
          setCurrentLoadBalance({
            ...currentLoadBalance,
            totalPrice: 0,
            totalCount: 0,
          }),
        );
        await dispatch(
          loadBalancesUpdate({ ...currentLoadBalance, periodType: newOrderProcessType }),
        );
        await dispatch(setDetailTableFilterClear());
        await loadBalanceDetailsGetPagedList({}, 1, 20);
        document.getElementById('loadBalanceFilterForm')?.reset();
      }
    } else {
      await dispatch(
        loadBalancesUpdate({ ...currentLoadBalance, periodType: newOrderProcessType }),
      );
      await dispatch(setDetailTableFilterClear());
      await loadBalanceDetailsGetPagedList({}, 1, 20);
      document.getElementById('loadBalanceFilterForm')?.reset();
    }
  };
  return (
    <>
      <CustomCollapseCard
        className={`order-type-card order-input-form-page ${excelLoadBalanceList?.orderStep === 3 || currentLoadBalance?.orderProcessType === 3
          ? 'excel-upload-card-container'
          : ''
          }`}
        bodyCenter
        cardTitle={<Text t="orderTypeTitle" />}
        cardTitleAlign="start"
      >
        <div className="order-type-container">
          <div className="card-checkbox-content">
            <Radio.Group
              id="ticketRestaurant-balanceUpload-balanceInformation-orderType-radioGroup"
              onChange={orderTypeChange}
              value={currentLoadBalance?.orderProcessType}
              className="custom-radio-input-credit-card order-balance-type-radio"
            >
              <div className="row justify-content-center">
                {currentLoadBalance?.isPreviousOrderExist && (
                  <Radio id="ticketRestaurant-balanceUpload-balanceInformation-orderType-radio1" value={1} className="card-radio">
                    <div className="card-label">
                      <Text t="repeatPreviousOrder" />
                    </div>
                    <p><Text t="youCanRepeatYourLastBalanceLoadingOrder" /></p>
                  </Radio>
                )}
                <Radio id="ticketRestaurant-balanceUpload-balanceInformation-orderType-radio2" value={2} className="card-radio">
                  <div className="card-label">
                    <Text t="manualBalanceLoading" />
                  </div>
                  <p>
                    <Text t="youCanEnterInformationForCardsYouWant" />
                  </p>
                </Radio>
                <Radio id="ticketRestaurant-balanceUpload-balanceInformation-orderType-radio3" value={3} className="card-radio">
                  <div className="card-label">
                    <Text t="balanceUploadWithExcel" />
                  </div>
                  <p>
                    <Text t="youCanUploadAnExcelFileForInformation" />
                  </p>
                </Radio>
                {currentLoadBalance?.isDraftedOrderExist && (
                  <Radio id="ticketRestaurant-balanceUpload-balanceInformation-orderType-radio4" value={4} className="card-radio">
                    <div className="card-label">
                      <Text t="fetchFromDraft" />
                    </div>
                    <p>
                      <Text t="youCanProceedWithThePreviouslyCreatedHalf" />
                    </p>
                  </Radio>
                )}
              </div>
            </Radio.Group>
          </div>
        </div>
      </CustomCollapseCard>

      {excelLoadBalanceList?.orderStep !== null || currentLoadBalance?.orderProcessType ? (
        <>
          {currentLoadBalance?.orderProcessType === 3 &&
            excelLoadBalanceList?.templateStep !== 0 ? (
            <CustomCollapseCard
              className="order-type-card montly-or-daily-card order-input-form-page"
              bodyCenter
              cardTitle={<Text t="orderPriceTypeTitle" />}
              cardTitleAlign="start"
            >
              <div className="order-type-container">
                <div className="card-checkbox-content">
                  <Radio.Group
                    id="ticketRestaurant-balanceUpload-balanceInformation-orderType-radioGroup3"
                    onChange={onProcessTypeChange}
                    value={currentLoadBalance.periodType}
                    className="custom-radio-input-credit-card order-balance-type-radio excel-radio"
                  >
                    <div className="row justify-content-center type-radio-container">
                      <Radio id="ticketRestaurant-balanceUpload-balanceInformation-orderType-radio8" value={0} className="card-radio">
                        <div className="card-label radio-label">
                          <Text t="dailyAmount" />
                        </div>
                        <p>
                          <Text t="youMustSpecifyHowManyTlOfBalance2" />
                        </p>
                      </Radio>
                      <Radio id="ticketRestaurant-balanceUpload-balanceInformation-orderType-radio7" value={1} className="card-radio">
                        <div className="card-label radio-label">
                          <Text t="monthlyAmount" />
                        </div>
                        <p>
                          <Text t="youMustSpecifyHowManyTlOfBalance" />
                        </p>
                      </Radio>
                    </div>
                  </Radio.Group>
                </div>
              </div>
            </CustomCollapseCard>
          ) : null}

          <CustomCollapseCard
            className="order-type-card montly-or-daily-card order-input-form-page"
            bodyCenter
            cardTitle={<Text t="orderPriceTypeTitle" />}
            cardTitleAlign="start"
          >
            <div className="order-type-container">
              <div className="card-checkbox-content">
                <Radio.Group
                  id="ticketRestaurant-balanceUpload-balanceInformation-orderType-radioGroup4"
                  onChange={onProcessTypeChange}
                  value={currentLoadBalance.periodType}
                  className="custom-radio-input-credit-card order-balance-type-radio excel-radio"
                >
                  <div className="row justify-content-center type-radio-container">
                    <Radio
                      id="ticketRestaurant-balanceUpload-balanceInformation-orderType-radio10"
                      value={0}
                      className="card-radio"
                    >
                      <div className="card-label radio-label">
                        <Text t="dailyAmount" />
                      </div>
                      <p>
                        <Text t="youMustSpecifyHowManyTlOfBalance2" />
                      </p>
                    </Radio>
                    <Radio
                      id="ticketRestaurant-balanceUpload-balanceInformation-orderType-radio9"
                      value={1}
                      className="card-radio"
                    >
                      <div className="card-label radio-label">
                        <Text t="monthlyAmount" />
                      </div>
                      <p>
                        <Text t="youMustSpecifyHowManyTlOfBalance" />
                      </p>
                    </Radio>
                  </div>
                </Radio.Group>
              </div>
            </div>
          </CustomCollapseCard>
        </>
      ) : null}
    </>
  );
};

export default OrderType;